import clsx from 'clsx'
import placeholderUrl from 'assets/image_placeholder.svg'
import styles from './imageContainer.module.scss'
import { WppSkeleton } from '@wppopen/components-library-react'

interface ImageContainerProps {
  imageUrl?: string
  alt?: string
  className?: string
  isInitialising?: boolean
}

export default function ImageContainer({ imageUrl, alt, className, isInitialising }: ImageContainerProps) {
  return isInitialising ? (
    <WppSkeleton variant="rectangle" height={600} className={styles.skeleton} data-testid="image-container-skeleton" />
  ) : (
    <div className={clsx(styles.image_container, className)}>
      <img src={imageUrl || placeholderUrl} alt={alt || 'product placeholder'} />
    </div>
  )
}
